<template>
  <v-menu v-model="isOpen" offset-y offset-x left nudge-right="45" :close-on-content-click="closeOnContentClick" eager>
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" v-bind="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" :color="color">
          <v-icon :small="small">{{ icon }}</v-icon>
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-text class="pa-0">
        <slot />
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ContextMenu extends Vue {
  @Prop({ default: "mdi-dots-vertical" })
  icon?: string;

  @Prop({ default: "" })
  color?: string;

  @Prop({ default: false })
  small?: boolean;

  @Prop({ default: false })
  closeOnContentClick?: boolean;

  /**
   * Optional `v-model` to control the menu from outside. If it is not set, the menu manages its state itself and
   * only emits `input` when it opens or closes, e.g. to keep an activator that is only rendered on hover alive.
   */
  @Prop({ default: null })
  value!: boolean | null;

  internalIsOpen = false;

  get isOpen() {
    return this.value === null ? this.internalIsOpen : this.value;
  }

  set isOpen(isOpen: boolean) {
    this.internalIsOpen = isOpen;
    this.$emit("input", isOpen);
  }
}
</script>
